import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import {
  IdExpressApplicationCatalogItem,
  IdExpressApplicationLogo,
} from "@id-express/global-user-navigation";
import "../StaticPage/StaticPage.css";
import "./Home.css";

const Home: React.FC = () => {
  const { t } = useTranslation();
  const applications = useOutletContext<IdExpressApplicationCatalogItem[]>() || [];
  const title = t("staticPages.home.title");
  const paragraphs = t("staticPages.home.body").split("\n").filter(Boolean);
  const closingParagraph = paragraphs.length > 1 ? paragraphs[paragraphs.length - 1] : undefined;
  const introductoryParagraphs = closingParagraph ? paragraphs.slice(0, -1) : paragraphs;

  useEffect(() => {
    document.title = `${title} · ID.Express`;
  }, [title]);

  return <article className="static-page home-page">
    <header className="home-hero">
      <span className="home-eyebrow" aria-hidden="true">ID.Express</span>
      <h1>{title}</h1>
      <div className="home-introduction">
        {introductoryParagraphs.map((paragraph, index) => <p key={index}>{paragraph}</p>)}
      </div>
    </header>
    {applications.length > 0 && <nav className="application-grid" aria-label={title}>
      {applications.map((application) => <a
        className="application-card"
        href={application.href}
        key={application.id}
      >
        <span className="application-logo-frame">
          <IdExpressApplicationLogo
            name={application.name}
            src={application.imageUrl}
            imageClassName="application-logo"
            fallbackClassName="application-logo-placeholder"
          />
        </span>
        <span className="application-name">{application.name}</span>
      </a>)}
    </nav>}
    {closingParagraph && <p className="home-closing-copy">{closingParagraph}</p>}
  </article>;
};

export default Home;
